
<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <EventTimeLine :timeIndex="status"></EventTimeLine>
      </zj-layout-header>
      <zj-layout-main>
        <EventInfo
          :EventConfirm="EventConfirm"
          :EventInfoEdit="EventInfoEdit"
          :EventSourceEdit="EventSourceEdit"
          :EventAffectEdit="EventAffectEdit"
          :EventConfirmEdit="EventConfirmEdit"
          :editable="editable"
          :EventReport="EventReport"
          :EventSummeryShow="EventSummeryShow"
          @FinishTime="getFinishTime"
        >
          <template name="default">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="16rem"
              class="finisheventform"
            >
              <el-collapse v-model="activeNames" style="margin-top: 2px">
                <el-collapse-item name="EmergencyCommand">
                  <template slot="title">
                    <i class="header-icon el-icon-arrow-down"></i>
                    <span class="spantitle">应急指挥：</span>
                  </template>
                  <el-form-item
                    label="应急结束时间"
                    style="display: inline-block"
                    v-if="finishTime"
                  >
                    <el-date-picker
                      type="datetime"
                      placeholder="选择日期"
                      v-model="finishTime"
                      disabled
                      :clearable="false"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item
                    label="接报核实耗时"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="Re_veTakeTime"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="态势分析耗时"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="SituationAnalysisTime"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="应急处置耗时"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="EmergencyResponseTime"
                      disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="任务派发量"
                    style="display: inline-block"
                  >
                    <el-input v-model="TaskVolume" disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="异常任务数量"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="UnusualTaskVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="任务完成数量"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="CompleteTaskVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="调动应急人员"
                    style="display: inline-block"
                  >
                    <el-input v-model="RescueVolume" disabled="true"></el-input>
                  </el-form-item>
                  <el-form-item
                    label="调动应急物资"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="MeterialVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="调动应急车辆"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      v-model="TransportVolume"
                      disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="应急处置成本估算"
                    prop="EventName"
                    style="display: inline-block"
                  >
                    <el-input
                      type="textarea"
                      rows="3"
                      v-model="ruleForm.costCalculation"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="EventSummary" class="EventSummary" v-if="ruleForm.status != 7">
                  <template slot="title">
                    <i class="header-icon el-icon-arrow-down"></i>
                    <span class="spantitle">事件总结</span>
                  </template>
                  <el-form-item label="事件总结">
                    <el-input
                      type="textarea"
                      rows="5"
                      v-model="ruleForm.eventSummary"
                      show-word-limit
                      maxlength="500"
                      disabled="true"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="善后负责人" prop="aftermathChargeId">
                    <el-select
                      v-model="ruleForm.aftermathChargeId"
                      disabled="true"
                    >
                      <el-option-group
                        v-for="group in UsersOptions"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>

                  <el-form-item
                    label="善后参与人"
                    prop="aftermathParticipant"
                    class="AfterparticipaterUsers"
                  >
                    <el-select
                      multiple
                      multiple-limit="10"
                      v-model="ruleForm.aftermathParticipant"
                      disabled="true"
                    >
                      <el-option-group
                        v-for="group in UsersOptions"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="善后处理意见">
                    <el-input
                      type="textarea"
                      rows="5"
                      v-model="ruleForm.aftermathOpinion"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-collapse-item>
                <el-collapse-item name="EventSummaryDesc" class="EventSummary" v-if="ruleForm.status == 6">
                  <template slot="title">
                    <i class="header-icon el-icon-arrow-down"></i>
                    <span class="spantitle">事件归档</span>
                  </template>
                  <el-form-item label="总结说明">
                    <el-input
                      type="textarea"
                      rows="5"
                      v-model="ruleForm.summaryDesc"
                      show-word-limit
                      maxlength="500"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="归档描述">
                    <el-input
                      type="textarea"
                      rows="5"
                      v-model="ruleForm.placeFileDesc"
                      disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-collapse-item>
              </el-collapse>
            </el-form> </template
        ></EventInfo>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import ZJApp from "../../../../../app";
import EventTimeLine from "./EventTimeLine.vue";
import EventInfo from "./EventInfo.vue";
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { aggregationResouceType, detail } from "@/api/src/emergency_event";
import { list } from "@/api/src/emergency_person";
import { list as commandTaskList } from "@/api/src/emergency_command_task";
export default {
  name: "ZjSeeEventInfo",
  controller: "UI",
  action: "SeeEventInfo",
  components: {
    EventTimeLine,
    EventInfo,
  },
  data() {
    return {
      status: parseInt(this.$route.query.Status),
      EventInfoEdit: true,
      EventSourceEdit: true,
      EventAffectEdit: true,
      EventConfirmEdit: true,
      EventSummeryShow: parseInt(this.$route.query.Status) === 7,
      editable: false,
      EventReport: this.$route.query.IsReport == null,
      Re_veTakeTime: "",
      SituationAnalysisTime: "",
      EmergencyResponseTime: "",
      TaskVolume: "",
      UnusualTaskVolume: "",
      CompleteTaskVolume: "",
      RescueVolume: "",
      MeterialVolume: "",
      TransportVolume: "",
      activeNames: ["EmergencyCommand", "EventSummary",'EventSummaryDesc'],
      ruleForm: {
        costCalculation: "",
        eventSummary: '',
        aftermathChargeId: "",
        aftermathParticipant: "",
        aftermathOpinion: "",
        id: "", //应
      },
      finishTime: null,
    };
  },
  created: function () {
    let { id } = this.$route.query
    this.ruleForm.id = id
    utils
      .waitAll([
        getDictionary('organization_type'),
        list({
          page:1,
          size:10000,
        }),
        detail( id ),
        commandTaskList({ eventId: id,current:1,size:10000 }),
        aggregationResouceType({ eventId: id })
      ])
      .then((r) => {
        this.GetUserData(r[0].data.records, r[1].data.records);

        const stat = r[2].data;
        //console.log(r);
        this.Re_veTakeTime = this.getDiff(stat.checkTime, stat.happenTime)
        this.SituationAnalysisTime = this.getDiff(stat.startTime, stat.checkTime)
        this.EmergencyResponseTime =  this.getDiff(new Date(), stat.reportTime)
        this.finishTime = stat.closeTime;
        stat.aftermathParticipant = JSON.parse(stat.aftermathParticipant)
        this.ruleForm = stat

        const TaskList = r[3].data.records;
        if(TaskList && TaskList.length){
          this.TaskVolume = TaskList.length;
          let Unusual = TaskList.filter(item=> item.status == 3)
          this.UnusualTaskVolume = Unusual ? Unusual.length : 0;
          let complete = TaskList.filter(item=> item.status == 2)
          this.CompleteTaskVolume = complete ? complete.length : 0;
        }else{
          this.TaskVolume = 0;
          this.UnusualTaskVolume = 0;
          this.CompleteTaskVolume = 0;
        }

        const ResouceInfo = r[4].data;
        if(ResouceInfo){
          ResouceInfo.map(item =>{
            if(item.resourceType == 1){
              this.RescueVolume = item.num
            }else if(item.resourceType == 2){
              this.MeterialVolume = item.num
            }else if(item.resourceType == 6){
              this.TransportVolume = item.num
            }
          })
        }else{
          this.RescueVolume = 0
          this.MeterialVolume = 0
          this.TransportVolume = 0
        }
      })
      .catch((e) => {
        console.error(e);
        this.hideLoading();
      });
  },
  methods: {
    getDiff(new_date, old_date){
      var new_date = new Date(new_date); 
      var old_date = new Date(old_date);
      var difftime = (new_date - old_date)/1000; //计算时间差,并把毫秒转换成秒
    
      var days = parseInt(difftime/86400); // 天  24*60*60*1000 
      var hours = parseInt(difftime/3600)-24*days;    // 小时 60*60 总小时数-过去的小时数=现在的小时数 
      var minutes = parseInt(difftime%3600/60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
      var seconds = parseInt(difftime%60);  // 以60秒为一整份 取余 剩下秒数

      return days + '天' + hours + "小时" + minutes + '分' + seconds + '秒'
    },
    showLoading(text) {
      this.loading = true;
      this.loadingText = text || "";
    },
    hideLoading() {
      this.loading = false;
    },
    onEventInfoShowLoading(e) {
      this.isEventInfoLoading = true;
      this.loadingText = e.text;
    },
    onEventInfoHideLoading() {
      this.isEventInfoLoading = false;
    },
    GetUserData(Fatoption, Chiloption) {
      this.ChildUser = Chiloption;
      var userOpt = [];
      for (var i = 0; i < Fatoption.length; i++) {
        var item = Fatoption[i];
        var users = [];
        for (var j = 0; j < Chiloption.length; j++) {
          var user = Chiloption[j];
          if (user.belongDeptType == item.code) {
            users.push({ value: user.id, label: user.name });
          }
        }
        userOpt.push({
          label: item.value,
          options: users,
        });
      }
      this.UsersOptions = userOpt;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>